import { produce } from 'immer';

import { useStore } from '../store';

export const setIsFullWidth = (value: boolean) => {
  useStore.setState(state =>
    produce(state, draft => {
      draft.embed.isFullWidth = value;
    })
  );
};

export const setContentWidth = (value: number) => {
  useStore.setState(state =>
    produce(state, draft => {
      draft.embed.contentWidth = value;
    })
  );
};

export const setIsOpen = (value: boolean) => {
  useStore.setState(state =>
    produce(state, draft => {
      draft.embed.isOpen = value;
    })
  );
};
